import { gql } from '@apollo/client';

// If you add fields under frameworkResults, remember to do the same for UPSERT_PROGRAMME_OVERVIEW
export const GET_PROGRAMME = gql`
  query GetProgramme($id: ID!) {
    programme: getProgramme(id: $id) {
      id
      name
      summary
      theoryOfChange
      serviceProviders {
        id
        name
      }
      funder {
        id
        name
      }
      fromDate
      toDate
      isArchived
      geographies {
        id
        name
      }
      frameworkType {
        id
        name
        levels {
          id
          name
          level
          allowIndicators
        }
      }
      frameworkResults {
        id
        type
        number
        description
        default {
          id
        }
        level {
          id
          level
        }
        parentResult {
          id
        }
        indicators {
          id
          measurementUnit
          type
          unit
          name
          startDate
          endDate
          target
          targetValue
          description
          resultRelationship
          hasTargets
          hasBaseline
          minValueAllowed
          maxValueAllowed
          dataSources
          timeline
          trackProgressStatus
          statusTier
          statusType
          outcomeTheme {
            id
            name
          }
          period {
            id
            name
          }
          categories {
            id
            category {
              id
              name
              status
            }
            option {
              id
              name
            }
          }
          dimensions {
            id
            index
            name
            options
          }
          benchmarks {
            id
            index
            name
            description
            benchmark {
              id
              name
              description
            }
          }
          periods {
            id
            periodDate
            periodNumber
            label
          }
          targets {
            id
            value
            periodDate
            periodNumber
            dimensionOptions
          }
          dataSource
          dataSourceOption
          datasetDataSource {
            id
            description
          }
          calculation
          calculationMethod
          dataSourceWorkspace {
            id
            name
          }
          includeEmptyRows
          baselineOrTargetValue
          baselineDate
          baselineValue
          trackingHierarchy {
            id
            name
          }
          trackingHierarchyLevel {
            id
            typeOfSite
            value
          }
          trackedByOrganisation
          calculateStatus
          basedOn
          allStatusOverides
          progressStatusConditions {
            id
            index
            status
            value1
            value2
            operator
          }
          trackingOrganisation
        }
      }
      owner {
        id
        firstName
        lastName
      }
      reporters {
        id
        assignee {
          id
          firstName
          lastName
        }
        organisation {
          id
          isFunder
          isInstitution
          isServiceProvider
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
      }
      parentProgramme {
        id
        name
        portfolios {
          id
          name
          owner {
            id
          }
        }
        geographies {
          id
          name
        }
        addOns {
          id
          name
        }
        currency
      }
      childProgrammes {
        id
        name
        budgetAmount
      }
      portfolios {
        id
        name
        owner {
          id
        }
      }
      theoryOfChangeFile {
        id
      }
      budgetAmount
      currency
      addOns {
        id
        name
      }
      monitoringForms {
        id
        name
        description
        captureValue
        version
        published
        supportingDocuments
        period {
          id
          name
        }
        indicators {
          id
          indicator {
            id
            name
            period {
              id
              name
            }
            frameworkResult {
              id
            }
            trackingHierarchy {
              id
              name
            }
            trackingHierarchyLevel {
              id
              typeOfSite
              value
            }
          }
          dimensions
        }
        reporters {
          id
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
        formReporters {
          id
          organisation {
            id
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
        }
        users {
          id
          reporter {
            id
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
          organisation {
            id
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
          user {
            id
            firstName
            lastName
            funder {
              id
              name
            }
            institution {
              id
              name
            }
            serviceProvider {
              id
              name
            }
          }
          formRole {
            id
            name
          }
        }
        dueDates {
          id
          date
          periodNumber
        }
        associatedForms {
          id
          name
          published
        }
        associatedActivities {
          id
          name
          intervention {
            id
            name
          }
        }
        sites {
          id
          site {
            id
            name
          }
          indicator {
            id
            name
          }
          hierarchyLevel {
            id
            typeOfSite
          }
        }
      }
    }
  }
`;
